import { CardWithIconAndTextAndTooltip } from "components/common/CardWithIconAndTextAndTooltip";
import * as React from "react";

type TradingPreferencesCardProps = {
    hoverText?: string,
    icon: React.ReactNode,
    id: string,
    isMobile: boolean,
    isSelected: boolean,
    name?: string,
    onClick: (id: string) => void,
}
export const TradingPreferencesCard = ({
    hoverText,
    icon,
    id,
    isMobile,
    isSelected,
    name = "",
    onClick
}: TradingPreferencesCardProps) => {

    const handleClick = () => {
        onClick(id);
    }

    return (
        <CardWithIconAndTextAndTooltip
            aria-label={name}
            checked={isSelected}
            hoverText={hoverText}
            icon={icon}
            isMobile={isMobile}
            text={name}
            width={isMobile ? 170 : 190}
            onClick={handleClick}
        />
    );
}


// WEBPACK FOOTER //
// ./src/components/tradingPreferences/components/TradingPreferencesCard.tsx